import { render, staticRenderFns } from "./VehicleFormModal.vue?vue&type=template&id=47855df2"
import script from "./VehicleFormModal.vue?vue&type=script&lang=js"
export * from "./VehicleFormModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleFormModal.vue?vue&type=style&index=0&id=47855df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports